import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  InAppBrowser,
  InAppBrowserOptions,
} from "@ionic-native/in-app-browser/ngx";
import { AlertController, LoadingController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { STORAGE } from "src/app/constant/storages";
import { _getStorage } from "src/app/utils/local-storage";
import { ApiserviceService } from "../../../httpservice/apiservice.service";

@Component({
  selector: "app-credit-note-preview",
  templateUrl: "./credit-note-preview.component.html",
  styleUrls: ["./credit-note-preview.component.scss"],
})
export class CreditNotePreviewComponent implements OnInit {
  confirmCreditNote: any = [];
  verifyCreditNote: any = "";
  isClick: boolean = false;
  showbtn = false;
  Active = 3;

  options: InAppBrowserOptions = {
    location: "yes", //Or 'no'
    hideurlbar: "yes",
    navigationbuttoncolor: "white",
    toolbarcolor: "red",
    toolbarposition: "top",
    closebuttoncaption: "CLOSE",
    closebuttoncolor: "white",
    hidden: "no", //Or  'yes'
    clearcache: "yes",
    clearsessioncache: "yes",
    zoom: "yes", //Android only ,shows browser zoom controls
    hardwareback: "yes",
    mediaPlaybackRequiresUserAction: "no",
    shouldPauseOnSuspend: "no", //Android only
    disallowoverscroll: "no", //iOS only
    toolbar: "yes", //iOS only
    enableViewportScale: "no", //iOS only
    allowInlineMediaPlayback: "no", //iOS only
    presentationstyle: "pagesheet", //iOS only
    fullscreen: "yes", //Windows only
  };

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";


  constructor(
    private iab: InAppBrowser,
    public storage: Storage,
    public alertController: AlertController,
    public apiservice: ApiserviceService,
    public loadingController: LoadingController,
    public route: ActivatedRoute
  ) { }

  ngOnInit() { }

  async ionViewWillEnter() {
    this.userID = _getStorage(STORAGE.userID)
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    await this.getStorageData();
  }

  async getStorageData() {
    const res = _getStorage(STORAGE.confirmCreditNote);
    this.confirmCreditNote = res.invoice_list;
  }

  async getPDF(item) {
    let target = "_self";
    const req_load_pdf = {
      taxno: item.creditnoteno,
      storebu: this.userBu,
      storeid: this.userLoc,
      userBu: this.userBu,
      userLoc: this.userLoc,
      userRole: this.userRole,
      userSource: this.userSource,
      user_id: this.userID,
      mtrans_id: item.mtrans_id
    };
    console.log("======== req load pdf =======: ", req_load_pdf);
    try {
      this.apiservice
        ._post(this.apiservice.apiUrl + this.apiservice.getNewPDF, req_load_pdf)
        .then((res) => {
          console.log("======== res load pdf =======: ", res);
          if (res.statusCode === 200) {
            const browser = this.iab.create(res.data, target, this.options);
            this.showbtn = true;
            item.isDownload = true;
          } else {
            this.ErrorMsg(res.statusMessage);
          }
        });
    } catch (error) {
      // this.ErrorMsg(errMsg.error);
    }
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  checkbranch(data: any) {
    // console.log('[-------data branch------]', data);
    if (data.buyer_type === "0") {
      return "-";
    } else if (data.buyer_type === "1") {
      if (data.branch === "00000") {
        return "สำนักงานใหญ่";
      } else {
        return data.branch;
      }
    } else if (data.buyer_type === "2") {
      return "-";
    } else {
      return "-";
    }
  }
  ionViewDidEnter() {
    this.route.queryParams.subscribe((params) => {
      if (params.noName === "no_cn") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 3;
      }
    });
  }
}
